define([
  'app/controller/auth',
  'app/controller/profiles',
  'app/controller/applications',
  'app/controller/companies',
  'app/controller/jobs',
  'app/controller/applicants',
  'app/controller/interests',
  'app/controller/resources',
  'app/controller/tests',
  'app/controller/universities',
  'app/controller/students',
  'app/controller/home',
  'app/controller/hiring_teams',
  'app/controller/partners',
  'app/controller/opportunities',
  'app/controller/email_templates',
  'app/controller/career_pages',
  'app/controller/tags',
  'app/controller/magazines',
  'app/controller/preferences',
  'app/controller/settings',
], () => {
  let instance = null;

  const Controller = function () {
    this.controller = this.getController();

    if (this.controller) {
      const actionName = `action${this.capitalizeFirstLetter(window.appConf.action)}`;
      console.log(actionName);

      if (actionName in this.controller) {
        this.controller[actionName].call(this.controller);
      }
    }
  };

  Controller.prototype.controller = null;

  Controller.prototype.getController = function () {
    let control = null;

    if (window.appConf) {
      try {
        control = window.appConf.control;
        return new (require(`app/controller/${control}`))();
      } catch (e) {
        console.log(e);
      }
    }

    return null;
  };

  Controller.prototype.capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getInstance = function () {
    if (!instance) {
      instance = new Controller();
    }

    return instance;
  };

  return getInstance;
});
